/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/api-v2-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { SegmentsGetStationStatusStatusesQueryResponse, SegmentsGetStationStatusStatusesQueryParams, SegmentsGetStationStatusStatuses400, SegmentsGetStationStatusStatuses401, SegmentsGetStationStatusStatuses403 } from "../models/SegmentsGetStationStatusStatuses";

export function getSegmentsGetStationStatusStatusesUrl() {
  const res = { method: 'GET', url: `/segments/v1/status` as const }
  return res
}

/**
 * @description Returns status (online/offline) and recent segments info for stations. A station is online if it has recorded a segment in the past threshold seconds. Includes latestAt (ISO string) indicating the most recent segment endTs. If ids query parameter is provided, returns status for those specific stations. If omitted, returns status for stations visible to the authenticated user.
 * @summary Get status for stations
 * {@link /segments/v1/status}
 */
export async function segmentsGetStationStatusStatuses(params?: SegmentsGetStationStatusStatusesQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<SegmentsGetStationStatusStatusesQueryResponse, ResponseErrorConfig<SegmentsGetStationStatusStatuses400 | SegmentsGetStationStatusStatuses401 | SegmentsGetStationStatusStatuses403>, unknown>({ method : "GET", url : getSegmentsGetStationStatusStatusesUrl().url.toString(), params, ... requestConfig })
  return res.data
}